export const newsletterFixture = ({
  link = 'https://www.calameo.com/read/004830137349816d9dc6c',
  title = 'Newsletter Adhérents',
  image = '/assets/images/newsletter-09-2026.png'
} = {}) => ({
  link,
  title,
  image
});